import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import configureStore from '@core/reducers/configureStore';
import UserReducer from '@core/reducers/UserReducer';
import ModalReducer from '@core/reducers/ModalReducer';
import AuthOptionsReducer from '@core/reducers/AuthOptionsReducer';
import SiteReducer from '@core/reducers/SiteReducer';
import ErrorBoundary from '@core/components/ErrorBoundary';
import Index from './components/Index';
import {siteSetData} from '@core/actions/SiteActions';
import installGlobalErrorReporter from '@common/helpers/installGlobalErrorReporter';

installGlobalErrorReporter('resume-auth');

const store = configureStore({
    site: SiteReducer,
    user: UserReducer,
    modal: ModalReducer,
    authOptions: AuthOptionsReducer,
});

const rootElement = document.getElementById('resume-auth-app');
const dataset = rootElement.dataset;

store.dispatch(siteSetData({
    lang: dataset.lang,
    parentSite: dataset.parentSite,
    parentSiteEmail: dataset.parentSiteEmail,
    signUpEnabled: !!parseInt(dataset.signUpEnabled),
    socialAuthStatus: !!parseInt(dataset.socialAuthStatus),
    socialAuthStatusGoogle: !!parseInt(dataset.socialAuthStatusGoogle),
    recaptchaSiteKey: dataset.recaptchaSiteKey,
}));

render(
    <Provider store={store}>
        <ErrorBoundary>
            <Index />
        </ErrorBoundary>
    </Provider>,
    rootElement,
);
